/* Atyab Premium — panier AJAX (Cart API + Section Rendering API) */
(function () {
  'use strict';

  var T = window.AtyabTheme || {};
  var routes = T.routes || {};
  var strings = T.strings || {};

  function sectionsToRender() {
    var ids = [];
    if (document.getElementById('shopify-section-cart-drawer')) ids.push('cart-drawer');
    var main = document.querySelector('[data-cart-section-id]');
    if (main) ids.push(main.getAttribute('data-cart-section-id'));
    return ids;
  }

  function replaceSection(id, html) {
    var source = new DOMParser().parseFromString(html, 'text/html');
    var incoming = source.querySelector('[data-cart-content]');
    var current = document.querySelector('#shopify-section-' + id + ' [data-cart-content]') ||
                  document.querySelector('[data-cart-content]');
    if (incoming && current) {
      current.innerHTML = incoming.innerHTML;
      document.dispatchEvent(new CustomEvent('atyab:section:rendered'));
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-count-label]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function applyResponse(data) {
    if (data.sections) {
      Object.keys(data.sections).forEach(function (id) { replaceSection(id, data.sections[id]); });
    }
    if (typeof data.item_count === 'number') updateCartCount(data.item_count);
    document.dispatchEvent(new CustomEvent('atyab:cart:updated', { detail: data }));
  }

  function refreshCount() {
    fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  function showError(scope, message) {
    var box = scope && scope.querySelector('[data-cart-error]');
    if (!box) { window.alert(message); return; }
    box.textContent = message;
    box.hidden = false;
    window.setTimeout(function () { box.hidden = true; }, 6000);
  }

  /* ---------- Ajout au panier ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[data-add-button]');
    var label = button ? button.querySelector('[data-add-label]') : null;
    var previous = label ? label.textContent : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.disabled = true; }
    if (label) label.textContent = strings.adding || 'Ajout…';

    var body = new FormData(form);
    var sections = sectionsToRender();
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }

    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          showError(form, result.data.description || result.data.message || strings.cart_error);
          return;
        }
        applyResponse(result.data);
        refreshCount();
        if (T.cartType === 'drawer' && document.getElementById('cart-drawer')) {
          window.AtyabDrawer.open('cart-drawer');
        } else {
          window.location.href = routes.cart_url;
        }
      })
      .catch(function () { showError(form, strings.cart_error || 'Une erreur est survenue.'); })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.disabled = false; }
        if (label) label.textContent = previous;
      });
  });

  /* ---------- Modification / suppression de ligne ---------- */
  function changeLine(key, quantity, scope) {
    if (scope) scope.classList.add('at-loading');
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionsToRender().join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) { showError(scope, result.data.message || strings.cart_error); return; }
        applyResponse(result.data);
      })
      .catch(function () { showError(scope, strings.cart_error || 'Une erreur est survenue.'); })
      .finally(function () { if (scope) scope.classList.remove('at-loading'); });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.getAttribute('data-cart-remove'), 0, remove.closest('[data-cart-content]'));
      return;
    }
    var step = event.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('[data-qty]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
      var min = parseInt(input.getAttribute('min'), 10) || 0;
      if (next < min) next = min;
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && next > max) next = max;
      if (String(next) === input.value) return;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  var debounceTimer;
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;
    var key = input.getAttribute('data-cart-qty');
    var scope = input.closest('[data-cart-content]');
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function () {
      changeLine(key, parseInt(input.value, 10), scope);
    }, 260);
  });

  /* ---------- Code promo (page panier) ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cart-note-form]');
    if (!form) return;
    event.preventDefault();
    var note = form.querySelector('textarea');
    fetch(routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note ? note.value : '' })
    }).then(function () {
      var status = form.querySelector('[data-note-status]');
      if (status) { status.hidden = false; window.setTimeout(function () { status.hidden = true; }, 4000); }
    });
  });
})();
